export { default } from './es/icons/OneToOneOutlined';